import axios from 'axios'
export default {
	namespaced: true,
	state: {
		contratos: [],
		contratoActual: null,
		filtro: {
			agente: null,
			cliente: null,
			fecha_inicio: null,
			fecha_fin: null,
			importe_min: null,
			importe_max: null,
			estado: null,
			descripcion: null
		}
	},
	getters: {
		filtro (state) {
			return {
				agente: state.agente,
				cliente: state.cliente,
				fecha_inicio: (state.fecha_inicio) ? new Date(state.fecha_inicio * 1000) : null,
				fecha_fin: (state.fecha_fin) ? new Date(state.fecha_fin * 1000) : null,
				importe_min: state.importe_min,
				importe_max: state.importe_max,
				estado: state.estado,
				descripcion: state.descripcion
			}
		},
		contratoActual (state) {
			return state.contratoActual
		}
	},
	mutations: {
		SET_FILTRO (state, data) {
			state.filtro = Object.assign(state.filtro, data)
		},
		SET_CONTRATO_ACTUAL (state, data) {
			state.contratoActual = Object.assign(state.contrato, data)
		}
	},
	actions: {
		getContrato (context, idContrato) {
			axios.get('mis-contratos/php/api/get-contrato.php?ID_contrato=' + idContrato)
				.then(res => {
					context.commit('SET_CONTRATO_ACTUAL', res.data.contrato)
				})
				.catch(e => {
					this.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error obteniendo el contrato'
					})
				})
		},
		/**
		 * Crearemos un nuevo contrato en fase de edición
		 * @param {} context
		 */
		nuevoContrato (context) {
			axios.get('mis-contratos/php/api/contrato/nuevo-contrato.php')
				.then(res => {
					context.commit('SET_CONTRATO_ACTUAL', res.data.contrato)
				})
				.catch(e => {
					this.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error creando el contrato'
					})
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/mis-contratos/vue/store.js